import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "casebox flex f-d a-c" }
const _hoisted_2 = {
  key: 0,
  class: "caseList"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "labelList flex" }
const _hoisted_5 = { class: "case-content" }
const _hoisted_6 = {
  key: 0,
  class: "case-imgList flex"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", { style: {"margin-right":"0.5rem"} }, "视频:", -1)
const _hoisted_8 = { class: "case-Video" }
const _hoisted_9 = {
  key: 1,
  class: "case-imgList flex"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "caseList"
}

import { onMounted, ref, watch } from "vue";
import Padding from "@/components/Layout/paging.vue";
import CheckType from "@/utils/CheckType";
import Video from "@/components/talkMessage/Video.vue";
import NotYetOpen from "@/components/NotYetOpen.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Case',
  props: {
    caseList: null
  },
  emits: ["sharecase"],
  setup(__props: any, { emit }) {

const props = __props as { caseList };

const newData = ref([]);

let caseList = ref([]);

const getDataOne = (data) => {
  newData.value = data;
};

const getList = () => {
  caseList.value.splice(0, caseList.value.length);
  caseList.value.push(...props.caseList);
};
watch(
  () => {
    return props.caseList.length;
  },
  () => {
    getList();
  }
);

onMounted(() => {
  getList();
});

const sharecase = () => {
  // 3为发布案例
  emit("sharecase");
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, { onClick: sharecase }, {
      default: _withCtx(() => [
        _createTextVNode("发布一个新的案例")
      ]),
      _: 1
    }),
    (_unref(caseList).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newData.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "case",
              key: index
            }, [
              _createElementVNode("h1", _hoisted_3, "标题：" + _toDisplayString(item.title || "暂无标题"), 1),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("h1", null, "标签：" + _toDisplayString(item.keywords ? "" : "暂无标签"), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.keywords, (item1, index1) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "label flex j-c a-c",
                    key: index1
                  }, _toDisplayString(item1.keyword), 1))
                }), 128))
              ]),
              _createElementVNode("div", _hoisted_5, " 内容：" + _toDisplayString(item.description || "暂无内容"), 1),
              (
            item.imageUrls && _unref(CheckType).checkFileType(item.imageUrls[0]) == 3
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(Video, {
                        item: { link: _unref(CheckType).isImg(item.imageUrls[0]) },
                        height: 5
                      }, null, 8, ["item"])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (item.imageUrls)
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_10, "图片："))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.imageUrls, (item2, index2) => {
                      return (_openBlock(), _createBlock(_component_el_image, {
                        class: "case-img",
                        src: _unref(CheckType).isImg(item2),
                        "preview-src-list": [_unref(CheckType).isImg(item2)],
                        key: index2,
                        fit: "cover"
                      }, null, 8, ["src", "preview-src-list"]))
                    }), 128))
                  ]))
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(NotYetOpen, { data: "暂无内容哦!" })
        ])),
    _withDirectives(_createVNode(Padding, {
      data: _unref(caseList),
      "page-size": 2,
      onGetData: getDataOne
    }, null, 8, ["data"]), [
      [_vShow, _unref(caseList).length > 0]
    ])
  ]))
}
}

})